import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs';
import {Moment} from './moment/moment';
import {DataSharing} from './data.sharing';

@Injectable()
export class HttpHelper {
    headers;
    contentTypes = {
        json: 'application/json',
        form: 'application/x-www-form-urlencoded; charset=utf-8',
        undefined: undefined,
        enctype: 'multipart/form-data',
    };

    constructor(private http: HttpClient) {
    }

    // tslint:disable-next-line:variable-name
    httpGet(url, contentType = 'form'): Observable<any> {
        return this.http.get(url, {headers: this.setHeader(contentType)});
    }

    httpPost(url, data, contentType = 'form'): Observable<any> {
        return this.http.post(url, data, {headers: this.setHeader(contentType)});
    }

    httpPut(url, data, contentType = 'form'): Observable<any> {
        return this.http.put(url, data, {headers: this.setHeader(contentType)});
    }

    httpPatch(url, data, contentType = 'form'): Observable<any> {
        return this.http.patch(url, data, {headers: this.setHeader(contentType)});
    }

    httpDelete(url, contentType = 'form'): Observable<any> {
        return this.http.delete(url, {headers: this.setHeader(contentType)});
    }

    fileUpload(url, data): Observable<any> {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + DataSharing.getToken()
        });
        return this.http.post(url, data, {headers: headers});
    }

    getContentType(type = 'form') {
        return this.contentTypes[type];
    }

    setHeader(contentType) {
        const pageToken = DataSharing.getPageToken() ? DataSharing.getPageToken() : '';
        const headers = {
            'Content-Type': this.getContentType(contentType),
            'time-zone': Moment.GetTimeZone(),
            Authorization: 'Bearer ' + DataSharing.getToken(),
            'Page-Token': pageToken,

        };
        return new HttpHeaders(headers);
    }
}
